import React from "react";
import ReactDOM from "react-dom";

import "./styles/reset.css";
import "./styles/main.css";

import App from "./App";

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
